import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import BackgroundEffects from './BackgroundEffects'; // Import background effects

// Define CSS for the interactive element - Add this to a relevant CSS file 
// (e.g., index.css or create AuthScreen.css and import it)
/*
.interactive-ui-container {
  perspective: 1000px; // Set perspective for the 3D effect
}

.interactive-ui-element {
  background-color: rgba(30, 30, 40, 0.7); // Example background
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  width: 400px; 
  height: 250px;
  transform-style: preserve-3d;
  transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: italic;
  color: #aaa;
}

.interactive-ui-container:hover .interactive-ui-element {
  transform: rotateX(10deg) rotateY(-15deg) translateZ(20px); // Rotate on hover
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
}
*/

const AuthScreen: React.FC = () => {
    const { signInWithGoogle, loading } = useAuth();

    return (
        <div className="relative flex flex-col items-center justify-center min-h-screen bg-background-primary text-white overflow-hidden">
            {/* Background Effects (same as chat page) */}
            <BackgroundEffects />
            {/* Noise Texture Overlay (same as chat page) */}
            <div
                className="fixed inset-0 pointer-events-none opacity-[0.025] z-0"
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
                }}
            />

            {/* Content Container */}
            <div className="relative z-10 flex flex-col items-center text-center p-8 max-w-4xl mx-auto">

                {/* Logo and App Name */}
                <div className="flex items-center mb-6">
                    <img src="/logos/versetaille.svg" alt="Versetaille Logo" className="h-12 w-12 mr-3" />
                    <h1 className="text-5xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                        Versetaille
                    </h1>
                </div>

                {/* Motto */}
                <p className="text-2xl md:text-3xl text-gray-300 mb-10">
                    Forget 10 subscriptions, you just need <span className="font-bold text-primary animate-pulse text-4xl">1</span>.
                </p>

                {/* Login Button */}
                <button
                    onClick={signInWithGoogle}
                    disabled={loading}
                    className="flex items-center justify-center bg-gradient-to-r from-primary to-secondary hover:opacity-90 disabled:opacity-50 text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-opacity duration-300 text-lg mb-16"
                >
                    {loading ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Signing In...
                        </>
                    ) : (
                        <>
                            <svg className="w-5 h-5 mr-3" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M44.5 20H42v-.5C42 11.029 33.471 2.5 24 2.5S6 11.029 6 21.5V22h18v12c0 1.105.895 2 2 2h16c1.105 0 2-.895 2-2V22c1.381 0 2.5-1.119 2.5-2.5S45.881 17 44.5 17zM15 21.5C15 14.042 20.042 9 26.5 9S38 14.042 38 21.5V22H15v-.5z" fill="#FFF" />
                                <path d="M43.611 20.083H22v16h16V22c1.105 0 2-.895 2-2v-.167c.01-.11.02-.22.02-.333 0-.69-.139-1.35-.409-1.917z" fill="#FFF" />
                            </svg>
                            Sign in with Google
                        </>
                    )}
                </button>

                {/* Interactive UI Preview Section */}
                <div className="w-full flex flex-col items-center">
                    <h2 className="text-xl text-gray-400 mb-4">Experience the Interface</h2>
                    {/* Add perspective container class */}
                    <div className="interactive-ui-container mb-4">
                        {/* Add element class and hover effect */}
                        <div className="interactive-ui-element">
                            {/* Placeholder Content */}
                            Chat UI Preview (Hover Me)
                        </div>
                    </div>
                    <p className="text-sm text-gray-500 max-w-md">
                        Get a glimpse of the clean and intuitive chat interface. (Note: This is a CSS representation, not a full 3D model)
                    </p>
                </div>

            </div>
        </div>
    );
};

export default AuthScreen; 